import axios from 'axios';
import type { PortalWithAssociationDataConfig } from 'Router/onboarding/types';

const getOnboardingPortalLaunchDatesAssociations = async (
  onboardingPortalId: string,
  orgId: string,
) => {
  if (!onboardingPortalId || !orgId) return;

  const url = `/onboarding-portal-launch-dates-associations/${onboardingPortalId}`;

  const { data } = await axios.get<PortalWithAssociationDataConfig>(url, {
    params: {
      orgId,
    },
  });

  return data;
};

export default getOnboardingPortalLaunchDatesAssociations;
